export default __webpack_public_path__ + "static/media/pattern-herringBone-40-1.4b8e6b6d.jpg";